import { render, staticRenderFns } from "./adiponectin.vue?vue&type=template&id=25460b46&scoped=true&"
import script from "./adiponectin.vue?vue&type=script&lang=js&"
export * from "./adiponectin.vue?vue&type=script&lang=js&"
import style0 from "./adiponectin.vue?vue&type=style&index=0&id=25460b46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25460b46",
  null
  
)

export default component.exports